export default {"src":"/_next/static/media/Colorado.6fa21823.svg","height":457,"width":800,"blurWidth":0,"blurHeight":0};